import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IInfo {
    loyaltyNumber: string,
    loyaltyLevel: number,
    nextLevelDate: string,
    loyaltyCash: number,
    bonuses: number,
    expireDate: string,
    expireBonuses: number,
    progressBar: number,
    registrationDate: string,
    cashbackPercentAfterLevelUp: number,
    maxLoyaltyCash: number,
    /**
     * Дата, до которой нужно внести платеж, чтобы получить кешбэк
     * Для договоров со схемой оплаты НСН дата = null
     * @see https://kb.ertelecom.ru/pages/viewpage.action?pageId=510826945
     */
    dateToPay?: string | null,
}

/*
* Информация о программе лояльности
* https://master.api-loyalty.sandbox.d2c.r-one.io/docs/v1#/Loyalty%20Program/95af4e7003e4622dcc2579c1c5ff77bf
* */
export const info = (providerId: number): IRequest => ({
    uri: '/v1/program/info',
    method: 'GET',
    withAuth: true,
    headers: { providerId: `${providerId}` },
});
